var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"PromptPageContent"}},[_c('div',{staticClass:"tipBox"},[_c('h1',{staticStyle:{"margin-bottom":"0.2rem"}},[_vm._v(_vm._s(_vm.$t('提示内容2')))]),_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('提示内容3')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }